import { render } from "./AddClass.vue?vue&type=template&id=8025e614&scoped=true"
import script from "./AddClass.vue?vue&type=script&lang=js"
export * from "./AddClass.vue?vue&type=script&lang=js"

import "./AddClass.vue?vue&type=style&index=0&id=8025e614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8025e614"]])

export default __exports__